<template>
  <div class="container-fluid">
    <div class="card-body">
      <b-row align-h="end" class="mb-3">
        <b-col cols="auto">
          <button
            class="btn btn-primary font-weight-bold mr-2"
            style="height: 38px"
            ref="import-orcamento-button"
            v-b-tooltip.top="
              'Importa somente orçamentos com status: Autorizado'
            "
            @click="buscarOrcamentos"
          >
            Importar Orçamento
          </button>
        </b-col>
      </b-row>
      <b-card>
        <b-tabs pills :horizontal="windowWidth < 768" :vertical="windowWidth > 768"
          :nav-wrapper-class="(windowWidth > 768 ? 'w-25' : 'w-100')" fill>
          <DadosGerais />
          <Objeto />
          <Problema />
          <Produto />
          <Servicos />
          <Pagamento />
          <Observacoes />
          <Anexos />
        </b-tabs>
      </b-card>
      <div class="card-footer">
        <div class="row">
          <div class="col-lg-12" style="text-align: center">
            <div v-if="canSaveOrdem">
              <div class="form mb-5">
                <button
                  v-if="!store.isUpdate"
                  class="btn btn-light-primary font-weight-bold mr-2"
                  @click="$bvModal.show('selecionarStatusOSModal')"
                  v-b-tooltip.top="'Selecionar status da OS'"
                >
                  <i class="flaticon2-checkmark mr-1"></i>
                  Status: {{ store.statusSelecionado?.descricao || "Aberta" }}
                </button>
                <button v-if="store.currentTab !== 0" class="btn btn-secondary font-weight-bold mr-2" @click="handlePrevious">
                  Anterior
                </button>
                <button v-if="store.isUpdate && store.currentTab !== 7" class="btn btn-primary font-weight-bold mr-4" @click="handleNext">
                  Próximo
                </button>
                <button ref="submit_nova_os" class="btn btn-primary font-weight-bold" @click="salvarOrdemServico">
                  Salvar
                </button>
                <button ref="submit_previa_nfe" class="btn btn-clean font-weight-bold"
                  @click="confirmCancel('ordensServicos')">
                  Cancelar
                </button>
              </div>
            </div>
            <div v-else>
              <button
                v-if="!store.isUpdate"
                class="btn btn-light-primary font-weight-bold mr-2"
                @click="$bvModal.show('selecionarStatusOSModal')"
                v-b-tooltip.top="'Selecionar status da OS'"
              >
                <i class="flaticon2-checkmark mr-1"></i>
                Status: {{ store.statusSelecionado?.descricao || "Aberta" }}
              </button>
              <button :disabled="store.currentTab === 0" class="btn btn-secondary font-weight-bold mr-4"
                @click="handlePrevious">
                Anterior
              </button>
              <button class="btn btn-primary font-weight-bold" @click="handleNext">
                Próximo
              </button>
              <button ref="submit_previa_nfe" class="btn btn-clean font-weight-bold"
                @click="confirmCancel('ordensServicos')">
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="selecionarStatusOSModal"
      title="Selecionar status da OS"
      centered
      size="sm"
    >
      <b-form-group label="Selecione o status" label-for="statusOS">
        <VueSelect
          ref="buscarStatusOS"
          :filterable="true"
          :options="osStatus"
          v-model="store.statusSelecionado"
        >
          <template slot="no-options"> Selecione o status </template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.descricao }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.descricao }}
            </div>
          </template>
        </VueSelect>
      </b-form-group>
      <template #modal-footer="{ cancel }">
        <b-button @click="cancel()"> Fechar </b-button>
      </template>
    </b-modal>
    <b-modal
      id="importarOrcamentoOS"
      title="Importar Orçamento"
      centered
      size="lg"
    >
      <b-form class="form">
        <b-row align-h="center">
          <b-col>
            <b-form-group :key="keyToReRender" label="Orçamento">
              <VueSelect
                ref="orcamento"
                :filterable="false"
                :options="orcamentosToImport"
                v-model="selectedOrcamento"
                @search="onSearchOrcamento"
              >
                <template slot="no-options"> Informe o orçamento</template>
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.numero }} - {{ option.cliente }}
                  </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.numero }} - {{ option.cliente }}
                  </div>
                </template>
              </VueSelect>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="primary"
          @click="importarOrcamento"
          ref="importar_orcamento"
        >
          Importar
        </b-button>
        <b-button
          @click="
            () => {
              selectedOrcamento = null;
              cancel();
            }
          "
        >
          Cancelar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import "vue-select/dist/vue-select.css";
import { validationMixin } from "vuelidate";
import FormatMixin from "../../Application/mixins/FormatMixin";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import { mask } from "vue-the-mask";
import PagamentosMixin from "../../Pdv/mixins/PagamentosMixin";
import InstallmentsMixin from "../../Application/mixins/InstallmentsMixin";
import DadosGerais from "./componentes/DadosGeraisTab.vue";
import Objeto from "./componentes/ObjetoTab.vue";
import Produto from "./componentes/ProdutoTab.vue";
import Servicos from "./componentes/ServicosTab.vue";
import Pagamento from "./componentes/PagamentoTab.vue";
import Problema from "./componentes/ProblemaTab.vue";
import Anexos from "./componentes/AnexosTab.vue";
import { store } from "../storeOS";
import Observacoes from "./componentes/ObservacoesTab.vue";
import _ from "lodash";
import swal from "sweetalert";
import VueSelect from "vue-select";

export default {
  name: "app-os-form",
  directives: {
    mask,
  },
  data() {
    return {
      store,
      windowWidth: window.innerWidth,
      formProduto: {},
      contasBancarias: [],
      orcamentosToImport: [],
      selectedOrcamento: null,
      keyToReRender: 0,
      osStatus: [],
    };
  },
  mixins: [
    validationMixin,
    FormatMixin,
    SistemaMixin,
    ValidacaoMixin,
    PagamentosMixin,
    InstallmentsMixin,
  ],
  components: {
    DadosGerais,
    Objeto,
    Problema,
    Produto,
    Servicos,
    Pagamento,
    Observacoes,
    Anexos,
    VueSelect,
  },
  watch: {
    total(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.valorTotal = newValue;
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });

    this.getDataInit();

    this.store.currentTab = 0;

    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
    }
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getDataInit() {
      try {
        const contasBancarias = await this.getBancosByEmpresa();
        this.contasBancarias = Array.isArray(contasBancarias)
          ? contasBancarias
          : [];
      } catch (error) {
        this.contasBancarias = [];
      }

      try {
        const { data } = await this.$http.post("/ordemservico/status");
        this.osStatus = data;
      } catch (error) {
        this.osStatus = [];
      }

      if (this.$route.params.nfeData.nfeId) {
        this.setLoading(true);
      }
    },
    async buscarOrcamentos() {
      const canImport = await this.confirmImportacaoOrcamento();
      if (!canImport) return;

      this.setLoading(true);
      try {
        const response = await this.$http.post(
          "/orcamento/orcamentos-autorizados"
        );
        this.orcamentosToImport = response.data.sort((a, b) => {
          if (a.id_orcamento < b.id_orcamento) return -1;
          if (a.id_orcamento > b.id_orcamento) return 1;
          return 0;
        });
        this.$bvModal.show("importarOrcamentoOS");
      } catch (error) {
        this.$toast.error("Erro ao buscar orçamentos autorizados");
        console.log(error);
      }
      this.setLoading(false);
    },
    onSearchOrcamento(search, loading) {
      loading(true);
      this.searchOrcamento(loading, search, this);
    },
    searchOrcamento: _.debounce(async (loading, search, vm) => {
      vm.orcamentosToImport = [];
      await vm.$nextTick();
      if (!search) {
        loading(false);
        return;
      }
      try {
        const response = await vm.$http.post(
          "/orcamento/orcamentos-autorizados",
          {
            numero: search,
          }
        );
        vm.orcamentosToImport = _.cloneDeep(response.data);
      } catch (error) {
        vm.$toast.error("Erro ao buscar orçamento");
        console.log(error);
      }
      loading(false);
    }, 500),
    async importarOrcamento() {
      if (!this.selectedOrcamento?.id_orcamento) {
        this.$toast.warning("Selecione um orçamento para importar");
        return;
      }

      this.addLoadingToButton("importar_orcamento");
      try {
        const orcamentos = [
          {
            id_orcamento: this.selectedOrcamento.id_orcamento,
          },
        ];
        const response = await this.$http.post(
          "/ordemservico/importar-orcamento",
          {
            orcamentos,
          }
        );

        this.aplicarOrcamentoImportado(response.data);

        this.store.orcamentos = orcamentos;

        this.$toast.success("Orçamento importado com sucesso!");
        this.$bvModal.hide("importarOrcamentoOS");
        this.selectedOrcamento = null;
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("importar_orcamento");
    },
    async atualizarStatusOrcamentosImportados() {
      if (!this.store.orcamentos || this.store.orcamentos.length === 0) return;

      try {
        await this.$http.post("/orcamento/update-status", {
          orcamentos: this.store.orcamentos,
          status: 13,
        });
      } catch (statusError) {
        console.log("Erro ao atualizar status do orçamento:", statusError);
      }
    },
    aplicarOrcamentoImportado(data) {
      const dadosImportados = {
        ...data,
        productOfTradeCollection:
          data?.productOfTradeCollection || data?.produtos || [],
      };
      const [, formProduto, formCliente] =
        this.extractDataFromImport(dadosImportados);

      if (formCliente) {
        this.store.formGerais = {
          ...(this.store.formGerais || {}),
          cliente: {
            ...formCliente,
            endereco:
              formCliente.endereco ||
              data?.shippingInfo?.address?.[0] ||
              data?.shippingInfo?.address ||
              null,
          },
          solicitante: data?.solicitante || this.store.formGerais?.solicitante,
        };
      }

      this.store.formProduto = this.normalizarProdutosImportados(formProduto);
      this.store.formPagamentos = this.normalizarPagamentosImportados(
        dadosImportados,
        this.store.formProduto.subtotal
      );
      this.store.formObservacoes = {
        ...(this.store.formObservacoes || {}),
        observacao:
          dadosImportados?.observation || dadosImportados?.observacao || "",
      };
      this.store.currentTab = 0;
    },
    normalizarProdutosImportados(formProduto) {
      const produtos = (formProduto?.produtos || []).map((produto, index) => ({
        ...produto,
        currentIndex: index,
      }));

      return {
        produtos,
        subtotal: produtos.reduce(
          (acc, produto) =>
            acc +
            (Number(produto.quantity || 0) * Number(produto.price || 0) -
              Number(produto.discount || 0)),
          0
        ),
      };
    },
    normalizarPagamentosImportados(data, subtotal) {
      const desconto = Number(data?.desconto || 0);
      const pagamentosOrigem =
        data?.pagamentos || data?.paymentModeCollection || [];

      return {
        ...(this.store.formPagamentos || {}),
        desconto,
        desconto_tipo: "valor",
        pagamentos: pagamentosOrigem.map((pagamento, index) => {
          const formaPagamento = pagamento.forma_pagamento || {
            id: pagamento.id || pagamento.paymentMode?.id,
            descricao:
              pagamento.descricao ||
              pagamento.description ||
              pagamento.paymentMode?.description,
            id_meio_pagamento:
              pagamento.id_meio_pagamento || pagamento.paymentMode?.id,
            vezes: pagamento.vezes || 1,
            requer_entrada: pagamento.requer_entrada || false,
            value: 0,
          };
          const valor =
            Number(pagamento.valor || pagamento.value || 0) ||
            (index === 0 ? Math.max(subtotal - desconto, 0) : 0);
          const parcelas = pagamento.range || [];
          const range = parcelas.length
            ? parcelas.map((parcela, parcelaIndex) => ({
                ...parcela,
                value:
                  Number(parcela.value || 0) ||
                  (index === 0 && parcelaIndex === 0 ? valor : 0),
              }))
            : [
                {
                  value: valor,
                  date: pagamento.vencimento || this.thisDate(),
                },
              ];

          return {
            forma_pagamento: formaPagamento,
            valor,
            vencimento: pagamento.vencimento || range[0]?.date || this.thisDate(),
            range,
          };
        }),
      };
    },
    async confirmImportacaoOrcamento() {
      if (!this.hasDadosOSPreenchidos) return true;

      const result = await this.$swal.fire({
        icon: "warning",
        title: "Importar orçamento?",
        text: "Os dados já preenchidos na OS serão substituídos pelas informações do orçamento.",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        confirmButtonColor: "#f64e60",
      });

      return result.isConfirmed;
    },
    resetStore() {
      this.store.formGerais = {};
      this.store.formObjeto = {};
      this.store.formProblema = {};
      this.store.formProduto = {};
      this.store.formServicos = {};
      this.store.formPagamentos = {};
      this.store.formObservacoes = {};
      this.store.formAnexos = {};
      this.store.orcamentos = [];
      this.store.statusSelecionado = { id: 1, descricao: "Aberta" };
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },

    handleSair() {
      this.$swal
        .fire({
          icon: "warning",
          title: "Cancelar o lançamento em andamento?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            this.$router.push({ name: "comprasLista" });
          }
        });
    },
    async salvarOrdemServico() {
      this.addLoadingToButton('submit_nova_os');
      const dataToSend = this.formatDataToSendToOSApi();
      try {
        if (Object.keys(this.$route.params).length !== 0) {
          const { id_ordem_servico } = this.$route.params.osData;
          // O status da OS e atualizado pela acao especifica da listagem.
          // Na edicao dos demais dados, preserva o status que ja esta salvo.
          dataToSend.delete("status");
          dataToSend.append("id_ordem_servico", id_ordem_servico);
          await this.$http.post('/ordemservico/update', dataToSend)
          this.$toast.success('Ordem de serviço atualizada com sucesso!')
          await this.atualizarStatusOrcamentosImportados();
          this.resetStore();
          this.$router.push({ name: "ordensServicos" });
        } else {
          await this.$http.post('/ordemservico/create', dataToSend)
          this.$toast.success('Ordem de serviço salva com sucesso!')
          await this.atualizarStatusOrcamentosImportados();
          this.resetStore();
          this.$router.push({ name: "ordensServicos" });
        }
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton('submit_nova_os');
    },

    imprimirPDF(id) {
      swal({
        title: "Deseja visualizar a prévia da NFe?",
        text: "Este documento ainda não tem validade fiscal, somente após ser autorizado!",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/nfe/print-nfe", {
            id: id,
          })
          .then((result) => {
            const resultData = result["data"]["danfe-url"];
            if (resultData) {
              window.open(result["data"]["danfe-url"], "_blank");
            }
            swal.stopLoading();
            swal.close();
            this.$toast.success("PDF gerado com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    handleNext() {
      if (this.store.currentTab === 7) return;
      this.store.currentTab++;
    },
    handlePrevious() {
      if (this.store.currentTab === 0) return;
      this.store.currentTab--;
    },
    checkNutsDigital() {
      if (!this.canGenerateBoleto) {
        return "Configure uma integração de boleto nas contas bancárias para gerar boletos.";
      }

      return "Os boletos serão enviados para o e-mail do cliente, conforme está lançado na NFe";
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "nutsDigital",
    ]),
    ...mapState(["loading"]),
    temSicoobApi() {
      return this.contasBancarias?.some((conta) => {
        const banco = String(conta?.banco || "")
          .replace(/^0+/, "")
          .toUpperCase();
        const nome = String(
          conta?.nome || conta?.banco_zoop?.name || conta?.descricao || ""
        ).toUpperCase();
        const statusApi = String(conta?.status_api || "").toLowerCase();

        return (
          (banco === "756" || nome.includes("SICOOB")) &&
          Boolean(conta?.integracao_api) &&
          statusApi === "ativo" &&
          Boolean(conta?.client_id) &&
          Boolean(conta?.numero_contrato) &&
          Boolean(conta?.conta)
        );
      });
    },
    canGenerateBoleto() {
      return Boolean(this.nutsDigital || this.temSicoobApi);
    },
    isLoading() {
      return this.loading.loading;
    },
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    toolbarDisplay() {
      return true;
    },
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
    displaySubheaderOnDashboard() {
      return this.$route.name !== "dashboard";
    },
    canSaveOrdem() {
      return this.store.currentTab === 7 || this.store.isUpdate;
    },
    hasDadosOSPreenchidos() {
      return (
        !!this.store.formGerais?.cliente?.id_pessoa ||
        (this.store.formProduto?.produtos || []).length > 0 ||
        (this.store.formServicos || []).length > 0 ||
        (this.store.formPagamentos?.pagamentos || []).length > 0 ||
        !!this.store.formProblema?.problema ||
        !!this.store.formObservacoes?.observacao
      );
    },
  },
  created() {
    this.store.dataFetching.servicos = true;
    this.store.dataFetching.produtos = true;
    this.store.isUpdate = false;
    if (Object.keys(this.$route.params).length !== 0) {
      this.store.isUpdate = true;
    } else {
      // Nova OS: limpa resquícios (pagamentos, produtos, etc.) de uma OS
      // anterior que tenham ficado no store singleton entre navegações.
      // O created() do pai roda antes do created() dos filhos (ex.: PagamentoTab),
      // então os filhos encontram o store limpo. Edição/importação não passam
      // por aqui (têm $route.params) e continuam funcionando.
      this.resetStore();
    }
  },
};
</script>

<style>
@media (max-width: 991.98px) {
  .container {
    padding: 0
  }

  .card-body-container {
    padding: 0rem;
  }

  .card-body {
    padding: 1rem;
  }
}

.action-buttons {
  display: flex;
}

.cardHeader {
  display: flex;
  max-width: 11rem;
  justify-content: center;
  background-color: white;
  margin-bottom: 5px;
  border-radius: 14px;
  padding: 0.5rem;
  margin-left: auto;
}

.busca-produto .vs__search {
  font-weight: 400;
  font-size: 1.45rem !important;
  margin-bottom: 0.5rem !important;
  line-height: 1.2 !important;
  text-transform: uppercase !important;
}

.busca-produto .vs__dropdown-toggle {
  border: 0px !important;
}

.busca-produto .vs__actions {
  display: none;
}

.busca-produto .vs__selected-options {
  max-width: 100%;
  flex-wrap: initial;
}

.busca-produto .vs__selected {
  text-align: left !important;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.busca-cliente .vs__search {
  font-size: 18px;
}

.busca-cliente .vs__dropdown-toggle {
  color: var(--primary-color);
  background-color: #fff;
  border: 2px solid #dedede;
  height: 40px;
}

.busca-cliente .vs--open .vs__dropdown-toggle {
  background-color: #fff;
  border: 2px solid var(--primary-color);
}

.busca-cliente .vs__actions {
  display: none;
}

.busca-cliente .vs__dropdown-option--highlight,
.vs__dropdown-menu li:hover,
.vs__dropdown-menu li:focus {
  background-color: var(--primary-color)5e !important;
  color: var(--primary-color) !important;
}

.busca-cliente .vs__dropdown-menu {
  color: var(--primary-color) !important;
}

.busca-cliente .vs__selected-options {
  max-width: 100%;
  flex-wrap: initial;
}

.busca-cliente .vs__selected {
  text-align: left !important;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.remove-pgto {
  font-weight: bold;
  font-size: 18px;
  color: #4f4f4f;
}

.add-pgto {
  font-weight: bold;
  font-size: 22px;
  color: var(--primary-color);
  float: right;
}

.input-quantidade {
  font-size: 1.75rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  background: transparent;
  border: transparent;
  color: #fff;
  padding: 0px;
  margin-top: -10px;
  margin-bottom: 0px;
  text-align: right;
}

.input-quantidade:focus {
  box-shadow: 0 0 0 0;
  border: 0 none;
  outline: 0;
  border: 0px;
  background-color: transparent;
  color: #fff;
}

.card {
  border: 0;
}

h4 {
  color: #6d747c;
  /* font-weight: 900; */
}

.btn-finalizar-venda {
  background-color: #eee5ff !important;
  font-size: 1.25rem !important;
  text-align: center !important;
  cursor: pointer;
}

.card-total-right p,
.card-total-left p {
  color: #fff !important;
}

.card-header h5,
.card-header h3 {
  margin-bottom: 0rem;
}

.card-header .form-control {
  height: auto;
  margin-top: 0px;
}

.card-header .busca-produto {
  margin-top: 2px;
}


.card-titulo-itens .card-body-container {
  padding: 0px 0 !important;
}

.card-itens .table tr th {
  padding: 5px;
  font-size: 12px;
}

.card-itens .table tr td,
.card-total-right p,
.card-total-left p {
  font-size: 12px;
}

.tableItensCompra {
  max-height: 300px !important;
  height: calc(100vh - 395px) !important;
}

.card-total-left,
.card-total-right {
  height: 80px !important;
}

.btn.btn-secondary {
  color: var(--primary-color);
  background-color: #fff;
  border-color: #fff;
}
</style>
